<template>

	<div class="g-searchspring__container" v-if="hasResults || Screen == 'SRCH'">
		<cart-toast :results="searchData.results" />
		<div class="g-searchspring__header">
			<banner :merchandising="searchData.merchandising" type="header" />
		</div>
		<div class="g-searchspring__content g-layout g-layout--justify-center">
			<div v-if="hasResults" id="js-searchsrping-facets" class="g-searchspring__div g-layout__item u-width-12 u-width-3--l">
				<facets :breadcrumbs="searchData.breadcrumbs" :facets="searchData.facets" :filterSummary="searchData.filterSummary" :pagination="searchData.pagination" />
				<banner :merchandising="searchData.merchandising" type="left" />
			</div>
			<div class="g-searchspring__results g-layout__item u-width-12 u-width-9--l">
				<search-results
					:facets="searchData.facets"
					:filterSummary="searchData.filterSummary"
					:merchandising="searchData.merchandising"
					:pagination="searchData.pagination"
					:results="searchData.results"
					:sorting="searchData.sorting"
					:didYouMean="searchData.didYouMean" />
			</div>
		</div>
		<div class="g-searchspring__footer">
			<banner :merchandising="searchData.merchandising" type="footer" />
		</div>
	</div>

</template>

<script>
	import Search from '../../Search';
	import SearchResults from './SearchResults';
	import Facets from './Facets';
	import Banner from './Banner';
	import SortBy from './SortBy';
	import CartToast from './CartToast';
	import {processMiddleware} from '../../middleware/process-middleware';
	import {updateResults, insertInlineBanners} from '../../middleware/middleware';


	// Define parameter removelist for routing
	const paramRemoveList = [
		/siteId=.*/,
		/resultsFormat=.*/,
		/bgfilter\..*=.*/,
		/q=.*/,
		/page=1/,
		/tag=.*/
	];

	// Create filtering function
	function requestParamsReducer(params, param) {
		return {
			...params,
			...(!paramRemoveList.some((regex) => regex.test(`${param}=${this[param]}`)))
				? {[param]: this[param]}
				: {}
		};
	}

	export default {
		data() {
			return {
				loader: {
					active: true,
					className: 'g-product-listing-loader--loading',
					containerElement: document.getElementById('js-product-listing-loader-container'),
					element: document.getElementById('js-product-listing-loader')
				},
				query: null,
				Screen: mivaJS.Screen,
				searchData: {},
				windowWidth: window.innerWidth
			}
		},
		created() {
			// Popstate
			window.addEventListener('popstate', () => {
				const queryKeys = Object.keys(this.$route.query);
				const queryCount = queryKeys?.length ?? 0;

				if (queryCount === 0 || (queryCount === 1 && queryKeys[0].toUpperCase() === 'SEARCH')) {
					history.back();
				} else {
					Search.client
						.reset()
						.setState(this.$route.query)
						.search();
				}
			});

			// Set state from URL
			Search.client.setState(this.$route.query);

			// Set query
			this.query = Search.client.states.search.params.q;

			// Bind event listener
			Search.client.on('search', (e) => this.onSearch(e.detail));

			// Run default search
			Search.client.search();
		},
		methods: {
			handleLoading () {
				if (!this.loader.active || !this.loader.containerElement || !this.loader.element) {
					return;
				}

				this.loader.containerElement.classList.remove(this.loader.className);

				this.loader.active = false;

				setTimeout(() => {
					this.loader.element.remove();
				}, 350)
			},
			async onSearch(request = {}) {
				// Handle merchandising redirects
				if (request.response?.data?.merchandising?.redirect) {
					window.location.replace(window.location.origin + request.response.data.merchandising.redirect);

					return;
				}

				// process middleware
				this.searchData = await processMiddleware(
					request.response.data,
					[
						updateResults(),
						insertInlineBanners()
					]
				);

				if (window.mivaJS?.Page_Code === 'SRCH' && Search.client?.states?.search?.params?.tag) {
					document.querySelector('.g-product-list-header__heading')?.classList.add('u-hide-visually');
				}

				// Define props to trickle down
				this.query = Search.client.states.search.params.q;
				this.merchandisingContent = this.searchData?.merchandising?.content ? this.searchData.merchandising.content : {};

				// Filter params by removelist
				const params = Object.keys(request.requestParams).reduce(requestParamsReducer.bind(request.requestParams), {});

				// Update router
				this.$router.push({query: params}).catch((err) => {
					return {};
				});

				// Force refresh of the view
				this.$forceUpdate();

				if (this.loader.active) {
					this.handleLoading();
				}

			}
		},
		computed: {
			hasResults () {
				return this.searchData.results?.length ? true : false;
			}
		},
		components: {
			'search-results': SearchResults,
			'facets': Facets,
			'banner': Banner,
			'sort-by': SortBy,
			'cart-toast': CartToast
		}
	}
</script>
